import { Link } from 'react-router-dom';

import { Logo } from '../components';
import { FacebookF, Github, Lock, Twitter } from '../icons';

const socialButtonClass =
  'group flex-1 bg-transparent border-2 border-gray-300 focus:outline-none focus:border-primary-500 opacity-60 hover:opacity-100 focus:opacity-100 rounded-md flex items-center justify-center transition-opacity';

const socialIconClass = 'group-focus:text-primary-500 w-10 h-10';

const SignUp = () => (
  <section className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-100 dark:bg-gray-900 dark:text-white">
    <div className="max-w-lg w-full space-y-8">
      {/* Header */}
      <div>
        <Link to="/" className="flex justify-center">
          <Logo />
        </Link>
        <h2 className="mt-6 text-center text-3xl font-extrabold">
          Create your account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-300">
          Or{' '}
          <Link
            to="/sign-in"
            className="font-medium text-primary-500 hover:underline"
          >
            sign in to your account
          </Link>
        </p>
      </div>

      {/* Card */}
      <div className="rounded-md shadow-lg py-8 sm:py-10 px-6 sm:px-12 space-y-6 bg-white dark:bg-gray-800">
        <form className="space-y-8" onSubmit={e => e.preventDefault()}>
          <div className="space-y-6">
            <div className="flex flex-col sm:flex-row space-y-6 sm:space-y-0 sm:space-x-4">
              {/* Input group: first name */}
              <div className="flex-1 flex flex-col">
                <label
                  htmlFor="first-name"
                  className="text-gray-600 dark:text-gray-300 font-medium mb-1"
                >
                  First name
                </label>
                <input
                  type="text"
                  name="first-name"
                  id="first-name"
                  required
                  className="border-2 border-gray-300 rounded-md w-full text-gray-900 focus:outline-none focus:border-primary-500"
                />
              </div>

              {/* Input group: last name */}
              <div className="flex-1 flex flex-col">
                <label
                  htmlFor="last-name"
                  className="text-gray-600 dark:text-gray-300 font-medium mb-1"
                >
                  Last name
                </label>
                <input
                  type="text"
                  name="last-name"
                  id="last-name"
                  required
                  className="border-2 border-gray-300 rounded-md w-full text-gray-900 focus:outline-none focus:border-primary-500"
                />
              </div>
            </div>

            {/* Input group: email */}
            <div className="flex flex-col">
              <label
                htmlFor="email-address"
                className="text-gray-600 dark:text-gray-300 font-medium mb-1"
              >
                Email address
              </label>
              <input
                type="email"
                name="email"
                id="email-address"
                required
                className="border-2 border-gray-300 rounded-md w-full text-gray-900 focus:outline-none focus:border-primary-500"
              />
            </div>

            <div className="flex flex-col sm:flex-row space-y-6 sm:space-y-0 sm:space-x-4">
              {/* Input group: password */}
              <div className="flex-1 flex flex-col">
                <label
                  htmlFor="password"
                  className="text-gray-600 dark:text-gray-300 font-medium mb-1"
                >
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  required
                  className="border-2 border-gray-300 rounded-md w-full text-gray-900 focus:outline-none focus:border-primary-500"
                />
              </div>

              {/* Input group: confirm password */}
              <div className="flex-1 flex flex-col">
                <label
                  htmlFor="confirm-password"
                  className="text-gray-600 dark:text-gray-300 font-medium mb-1"
                >
                  Confim password
                </label>
                <input
                  type="password"
                  name="confirm-password"
                  id="confirm-password"
                  required
                  className="border-2 border-gray-300 rounded-md w-full text-gray-900 focus:outline-none focus:border-primary-500"
                />
              </div>
            </div>
          </div>

          {/* Submit button */}
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-4 focus:ring-primary-500 focus:ring-opacity-50"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                {/* Heroicon name: solid/lock-closed */}
                <Lock className="h-5 w-5 text-primary-400 group-hover:text-primary-300" />
              </span>
              Sign in
            </button>
          </div>
        </form>

        {/* Divider */}
        <div className="flex items-center justify-center">
          <hr className="flex-1 border-t-2 mr-3" />
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Or continue with
          </p>
          <hr className="flex-1 border-t-2 ml-3" />
        </div>

        {/* Authentication providers */}
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
          <button className={socialButtonClass}>
            <FacebookF className={socialIconClass} />
          </button>
          <button className={socialButtonClass}>
            <Twitter className={socialIconClass} />
          </button>
          <button className={socialButtonClass}>
            <Github className={socialIconClass} />
          </button>
        </div>
      </div>
    </div>
  </section>
);

export default SignUp;
